import { Components, Theme } from "@mui/material";

export const MuiButtonBase: Components<
  Omit<Theme, "MuiButtonBase">
>["MuiButtonBase"] = {
  defaultProps: {
    disableRipple: false,
  },
};
